import React, { useEffect } from 'react'

import { Provider } from 'react-redux'
import store from '@redux/store'


import {
  BrowserRouter as Router,
  Redirect,
  Switch,
  Route
} from 'react-router-dom'

import { ToastContainer } from 'react-toastify'

import dayjs from 'dayjs'
import { useIntl } from 'react-intl'

import ActionConfirmationModal from '@components/action-confirmation-modal/action-confirmation-modal.component'
import AppRedirect from '@components/app-redirect/app-redirect.component'
import NotAuthorized from '@components/not-authorized/not-authorized.component'
import NotFound from '@components/not-found/not-found.component'
import Push from '@components/push/push.component'
import PushReg from '@components/push-reg/push-reg.component'
import ErrorModal from '@components/error-modal/error-modal.component'
import FilesModal from '@components/files-modal/files-modal.component'
import TipSuccessModal from '@components/tip-success-modal/tip-success-modal.component'
import SearchLightConfirmationModal from '@components/searchlight-confirmation-modal/searchlight-confirmation-modal.component'
import { useMediaPredicate } from 'react-media-hook'
import useStyles from './App.style'

import 'react-image-lightbox/style.css'
import '@voxeet/react-components/dist/voxeet-react-components.css'
// import 'react-image-lightbox/style.css'

import '@sass/App.sass'

import i18n from 'i18n-js'
import TRANSLATIONS from './assets/i18n/translations'

const duration = require('dayjs/plugin/duration')
const localizedFormat = require('dayjs/plugin/localizedFormat')
const relativeTime = require('dayjs/plugin/relativeTime')
const isBetween = require('dayjs/plugin/isBetween')
const utc = require('dayjs/plugin/utc')

dayjs.extend(duration)
dayjs.extend(localizedFormat)
dayjs.extend(relativeTime)
dayjs.extend(isBetween)
dayjs.extend(utc)

const App = () => {
  useStyles()
  const intl = useIntl()

  i18n.fallbacks = true
  i18n.translations = TRANSLATIONS
  i18n.locale = intl.locale

  const preferredTheme = useMediaPredicate('(prefers-color-scheme: dark)') ? 'dark' : 'light'

  useEffect(() => {
    const theme = document.querySelector('[data-theme]')

    theme.setAttribute('data-theme', preferredTheme)
  }, [preferredTheme])

  return (
    <Provider store={store}>
      <Router>
        <AppRedirect />
        <Switch>
          <Route
            exact
            path='/:personalAccessCode/registration'
          >
            <PushReg />
          </Route>
          <Route
            path='/404'
          >
            <NotFound />
          </Route>
          <Route
            path='/403'
          >
            <NotAuthorized />
          </Route>
          <Route path='/:personalAccessCode'>
            <Push />
          </Route>
          <Redirect
            from='/**/'
            to='/404'
          />
        </Switch>
      </Router>
      <ActionConfirmationModal />
      <ToastContainer />
      <ErrorModal />
      <FilesModal />
      <TipSuccessModal />
      <SearchLightConfirmationModal />
    </Provider>
  )
}

export default App
